import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './BusinessLogin.css';
import Topbar from "../../BusinessTopbar";
import Footer from "../../BusinessFooter";
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { validatelogin,validatelocationsearch } from '../../../Utils/validate';
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import { setUserSession } from '../../../Utils/Common';
import { gettoastwarning } from '../../../Utils/Common';

import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import Modal from 'react-bootstrap/Modal';
const BusinessLogin = () => {

	const [loading, setLoading] = useState(true);
	const [inputslogin, setInputslogin] = useState({});
	const [inputs, setInputs] = useState({ email: '', password: '', remember_me: false });

	const [inputsla, setInputsla] = useState({ lat: '', lng: '', single_address: '',address:'',city_id:'',town_id:'' });


	const [inputsl, setInputsl] = useState({ pincode: '', state: '', city: '', town: '',town_name:'' });

	const [inputst, setInputst] = useState({ title: '', sub_title: '', image1: '', image2: '', image3: '' });



	const [errors, setErrors] = useState({});

	const [show, setShow] = useState(false);


	const [state, setState] = useState([]);
    const [city, setCity] = useState([]);
    const [town, setTown] = useState([]);

	const [shows, setShows] = useState(false);
  	const handleCloses = () => setShows(false);
  	const handleShows = () => setShows(true);

	const GoogleSignInButton = () => {
		//const [loading,setLoading] = useState(false);

		const login = useGoogleLogin({
			onSuccess: (tokenResponse) => {
				const accessToken = tokenResponse.access_token;
				fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
					headers: {
						Authorization: `Bearer ${accessToken}`,
					},
				})
					.then(response => response.json())
					.then(profile => {

						//console.log("Google profile:", profile);
						var email = profile.email;
						var provider_id = profile.sub;
						//var first_name=profile.given_name;
						//var last_name=profile.family_name;

						var name = profile.name; 
						var firstName = profile.given_name; 
						var lastName = profile.family_name;

						// Example usage:
						let formData = new FormData();
						formData.append('email', email);
						formData.append('type', 2);
						formData.append('login_type', 'gmail');
						formData.append('social_token', provider_id);
						formData.append('name', name);
						formData.append('first_name', firstName);
						formData.append('last_name', lastName);
						API.post('login_with_social', formData)
							.then(response => {
								if (response.data.status === false) {
									gettoastwarning(response.data.message, '');
									setLoading(false);
								} else {
									setLoading(false);
									if (response.data.data.role === 2) {
										const expiryTime = Date.now() + 3600000;
										localStorage.setItem("session_expiry", expiryTime);
										localStorage.setItem("business_id", response.data.data.business_id);
										setUserSession(response.data.data.token, response.data.data.role);
										localStorage.setItem("location_id", response.data.data.location_id);
										localStorage.setItem("location_town", response.data.data.location_town_name);
										var loc = '';
										if (response.data.data.location_pincode !== '' && response.data.data.location_town_name !== '') {
											loc = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
										}
										localStorage.setItem("location", loc);
										var is_profile_verify=response.data.data.is_profile_verify;
										localStorage.setItem("is_profile_verify_buss", is_profile_verify);
										if(is_profile_verify===1){
											window.location.href = '/business/my-deal';
										}else{
											window.location.href = '/business/complete-profile';
										}

									} else if (response.data.data.role === 1) {
										if (response.data.data.is_popup_open === 0) {
											setInputslogin(response.data.data);
											setShow(true);
										} else {
											const expiryTime = Date.now() + 3600000;
											localStorage.setItem("session_expiry", expiryTime);
											localStorage.setItem("business_id", response.data.data.business_id);
											setUserSession(response.data.data.token, response.data.data.role);
											localStorage.setItem("location_id", response.data.data.location_id);
											localStorage.setItem("location_town", response.data.data.location_town_name);

											var loc1 = '';
											if (response.data.data.location_pincode !== '' && response.data.data.location_town_name !== '') {
												loc1 = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
											}
											localStorage.setItem("location", loc1);
											var is_profile_verify1=response.data.data.is_profile_verify;
											localStorage.setItem("is_profile_verify_buss", is_profile_verify1);
											if(is_profile_verify1===1){
												window.location.href = '/business/my-deal';
											}else{
												window.location.href = '/business/complete-profile';
											}
										}
									}
								}
							})
							.catch(error => {
								setLoading(false);
								gettoastwarning('Something went wrong. Please try again later.', '');
							});

					})
					.catch(error => {
						console.error("Error fetching Google profile:", error);
						setLoading(false);
						gettoastwarning('Failed to fetch user profile from Google.', '');
					});
			},
			onError: () => {
				console.log('Login Failed');
			},
		});
		return (
			<Link to="" className='go-btn' onClick={() => login()}><div><h6>Continue with Google</h6> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/googlewh.webp'} className="img-fluid" alt="googlewh" /></div></Link>
		);
	};

	useEffect(() => {
		document.title = `Business Login | Local Bells`;
		document.getElementById('bodywrap').className = 'buslogin';

		API.post('get_state')
        .then(response => {
            setState(response.data.data);
        });

		if (localStorage.getItem("remember_me_b")) {
			setInputs({
				email: localStorage.getItem("email_b"),
				password: localStorage.getItem("password_b"),
				remember_me: localStorage.getItem("remember_me_b")
			});
		}

		/* Start get login text */
        var url = 'business_login_page';
        API.post(url)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setInputst({ title: response.data.data.title, sub_title: response.data.data.sub_title, image1: response.data.data.image1, image2: response.data.data.image2, image3: response.data.data.image3 });
                }
            }).catch(error => {
                setLoading(false);
            });
        /* End get login text */


	}, []);

	const [showPassword, setShowPassword] = useState(false);
	const togglePassword = () => {
		setShowPassword(prevState => !prevState);
	};
	const handleSubmit = (e) => {
		e.preventDefault();
		//navigate('/neighbour/local-deals');
		const validationErrors = validatelogin(inputs);
		const noErrors = Object.keys(validationErrors).length === 0;
		setErrors({});
		setErrors(validationErrors);
		if (noErrors) {
			setLoading(true);

			let email = inputs.email;
			let password = inputs.password;

			let formData = new FormData();
			formData.append('email', email);
			formData.append('password', password);
			formData.append('type', 2);
			API.post('login', formData)
				.then(response => {
					if (response.data.status === false) {
						//setError(response.data.message);
						setLoading(false);
						gettoastwarning(response.data.message, '');
					} else {
						setLoading(false);
						if (response.data.data.role === 2) {
							const expiryTime = Date.now() + 3600000;
							localStorage.setItem("session_expiry", expiryTime);
							localStorage.setItem("business_id", response.data.data.business_id);
							setUserSession(response.data.data.token, response.data.data.role);
							localStorage.setItem("location_id", response.data.data.location_id);
							localStorage.setItem("location_town", response.data.data.location_town_name);

							var loc = '';
							if (response.data.data.location_pincode !== '' && response.data.data.location_town_name !== '') {
								loc = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
							}
							localStorage.setItem("location", loc);
							if (inputs.remember_me) {
								localStorage.setItem("remember_me_b", true);
								localStorage.setItem("email_b", email);
								localStorage.setItem("password_b", password);
							} else {
								localStorage.removeItem("remember_me_b");
								localStorage.removeItem("email_b");
								localStorage.removeItem("password_b");
							}
							var is_profile_verify=response.data.data.is_profile_verify;
								localStorage.setItem("is_profile_verify_buss", is_profile_verify);
								if(is_profile_verify===1){
									window.location.href = '/business/my-deal';
								}else{
									window.location.href = '/business/complete-profile';
								}
						} else if (response.data.data.role === 1) {
							if (response.data.data.is_popup_open === 0) {
								setInputslogin(response.data.data);
								setShow(true);
							} else {
								const expiryTime = Date.now() + 3600000;
								localStorage.setItem("session_expiry", expiryTime);
								localStorage.setItem("business_id", response.data.data.business_id);
								setUserSession(response.data.data.token, response.data.data.role);
								localStorage.setItem("location_id", response.data.data.location_id);
								localStorage.setItem("location_town", response.data.data.location_town_name);

								var loc1 = '';
								if (response.data.data.location_pincode !== '' && response.data.data.location_town_name !== '') {
									loc1 = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
								}
								localStorage.setItem("location", loc1);
								if (inputs.remember_me) {
									localStorage.setItem("remember_me_b", true);
									localStorage.setItem("email_b", email);
									localStorage.setItem("password_b", password);
								} else {
									localStorage.removeItem("remember_me_b");
									localStorage.removeItem("email_b");
									localStorage.removeItem("password_b");
								}
								var is_profile_verify2=response.data.data.is_profile_verify;
									localStorage.setItem("is_profile_verify_buss", is_profile_verify2);
									if(is_profile_verify2===1){
										window.location.href = '/business/my-deal';
									}else{
										window.location.href = '/business/complete-profile';
									}
							}
						}
					}
				}).catch(error => {
					setLoading(false);
					gettoastwarning("Something went wrong. Please try again later.", '');
					//setError("Something went wrong. Please try again later.");
				});
		}
	};

	/* Start Value set */
	const handleInputChange = (event) => {
		event.persist();
		setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
	}
	const handleCheckboxChange = (event) => {
		var remember_me_lbl = 'remember_me';
		setInputs(inputs => ({ ...inputs, [remember_me_lbl]: event.target.checked }));
	}
	/* End Value set */

	const responseFacebook = (response) => {
		console.log(response);
		if (!response.accessToken) {
			setLoading(false);
			gettoastwarning("Facebook login failed, please try again.", "/business/login");
		} else {
			var email = '';
			if (response.email) {
				email = response.email;
			}
			var name = response.name || '';     
			var firstName = response.first_name || ''; 
			var lastName = response.last_name || '';
			var id = response.id;

			setLoading(true);
			let formData = new FormData();
			formData.append('email', email);
			formData.append('type', 2);
			formData.append('login_type', 'facebook');
			formData.append('social_token', id);
			formData.append('name', name);
			formData.append('first_name', firstName);
			formData.append('last_name', lastName);
			API.post('login_with_social', formData)
				.then(response => {

					if (response.data.status === false) {
						gettoastwarning(response.data.message, '');
						setLoading(false);
					} else {
						setLoading(false);
						if (response.data.data.role === 2) {
							const expiryTime = Date.now() + 3600000;
							localStorage.setItem("session_expiry", expiryTime);
							localStorage.setItem("business_id", response.data.data.business_id);
							setUserSession(response.data.data.token, response.data.data.role);
							localStorage.setItem("location_id", response.data.data.location_id);
							localStorage.setItem("location_town", response.data.data.location_town_name);
							var loc = '';
							if (response.data.data.location_pincode !== '' && response.data.data.location_town_name !== '') {
								loc = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
							}
							localStorage.setItem("location", loc);
							var is_profile_verify=response.data.data.is_profile_verify;
							localStorage.setItem("is_profile_verify_buss", is_profile_verify);
							if(is_profile_verify===1){
								window.location.href = '/business/my-deal';
							}else{
								window.location.href = '/business/complete-profile';
							}
						} else if (response.data.data.role === 1) {
							if (response.data.data.is_popup_open === 0) {
								setInputslogin(response.data.data);
								setShow(true);
							} else {
								const expiryTime = Date.now() + 3600000;
								localStorage.setItem("session_expiry", expiryTime);
								localStorage.setItem("business_id", response.data.data.business_id);
								setUserSession(response.data.data.token, response.data.data.role);
								localStorage.setItem("location_id", response.data.data.location_id);
								localStorage.setItem("location_town", response.data.data.location_town_name);

								var loc1 = '';
								if (response.data.data.location_pincode !== '' && response.data.data.location_town_name !== '') {
									loc1 = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
								}
								localStorage.setItem("location", loc1);
								var is_profile_verify3=response.data.data.is_profile_verify;
								localStorage.setItem("is_profile_verify_buss", is_profile_verify3);
								if(is_profile_verify3===1){
									window.location.href = '/business/my-deal';
								}else{
									window.location.href = '/business/complete-profile';
								}
							}
						}
					}
				}).catch(error => {
					setLoading(false);
					gettoastwarning('Failed to fetch user profile from Google.', '');
				});
		}

	}
	const handleClose = () => setShow(false);
	const handleYes = () => {
		//localStorage.setItem("business_id", inputslogin.business_id);
		const expiryTime = Date.now() + 3600000;
		localStorage.setItem("session_expiry", expiryTime);
		setUserSession(inputslogin.token, inputslogin.role);
		localStorage.setItem("location_id", inputslogin.location_id);
		localStorage.setItem("location_town", inputslogin.location_town_name);

		var loc = '';
		if (inputslogin.location_pincode !== '' && inputslogin.location_town_name !== '') {
			loc = `${inputslogin.location_town_name} - ${inputslogin.location_pincode}`;
		}
		localStorage.setItem("location", loc);
		if (inputslogin.switch_business_to_customer === 1) {
			localStorage.setItem("business_id", inputslogin.switch_business_id);
			var is_profile_verify=inputslogin.is_profile_verify;
				localStorage.setItem("is_profile_verify_buss", is_profile_verify);
				if(is_profile_verify===1){
					window.location.href = '/business/my-deal';
				}else{
					window.location.href = '/business/complete-profile';
				}
		} else {
			window.location.href = '/neighbour/switch-business-profile';
		}
	};

const getCurrentLocationLogin = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        fetchAddressLogin(lat, lng);
      },
      (err) => alert("Location permission denied")
    );
  };

const fetchAddressLogin = async (lat, lng) => {
    const res = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyDeZEUk4duqBvkXPYcZL-FR3IgCK7EA9bM`
    );
    const data = await res.json();
    const components = data.results[0].address_components;

     const town =
    components.find(c =>
      c.types.includes("locality") ||
      c.types.includes("sublocality") ||
      c.types.includes("administrative_area_level_2")
    )?.long_name || "";

  const pincode =
    components.find(c => c.types.includes("postal_code"))?.long_name || "";
    var sortedAddress=town+' '+pincode;
    if (data.results?.length) {
    	setInputsla({ lat: lat, lng: lng, single_address: town,address:sortedAddress,city_id:'',town_id:'' });
    }
    
  };

const SubmitLocation = () => {
  if (
    inputsla.single_address &&
    inputsla.address
  ) {
    const newLocation = {
        lat:inputsla.lat,
        lng:inputsla.lng,
        single_address:inputsla.single_address,
        address: inputsla.address,
        city_id: inputsla.city_id,
        town_id: inputsla.town_id,
      };
      sessionStorage.setItem("cur_location", JSON.stringify(newLocation));
    window.location.href = "/deal";
  } else {
    gettoastwarning('Please select your current location to continue.', '');
  }
};

const handleInputChangeMo = (event) => {
    event.persist();
    const { name, value } = event.target;

    // Allow only numbers (0–9)
    const regex = /^[0-9]*$/;

    if (regex.test(value)) {
        setInputsl(inputsl => ({ ...inputsl, [name]: value }));
    }
}

const getpicode_town = () => {
        setCity([]);
        setTown([]);
        var state_label1 = 'state';
        var state1 = '';
        setInputsl(inputsl => ({ ...inputsl, [state_label1]: state1 }));

        var city_label1 = 'city';
        var city1 = '';
        setInputsl(inputsl => ({ ...inputsl, [city_label1]: city1 }));

        var town_label1 = 'town';
        var town1 = '';
        setInputsl(inputsl => ({ ...inputsl, [town_label1]: town1 }));
        if (inputsl.pincode !== '') {
            let formData = new FormData();
            formData.append('pin_code', inputsl.pincode);
            API.post('get_pincode_town', formData)
                .then(response => {

                    if (response.data.status === true) {
                        if (response.data.data.city_id !== '' && response.data.data.city_id !== '') {
                            setCity(response.data.data.city);
                            setTown(response.data.data.town);
                            var state_label = 'state';
                            var state = response.data.data.state_id;
                            setInputsl(inputsl => ({ ...inputsl, [state_label]: state }));

                            var city_label = 'city';
                            var city = response.data.data.city_id;
                            setInputsl(inputsl => ({ ...inputsl, [city_label]: city }));

                            var town_label = 'town';
                            var town = response.data.data.town_id;
                            setInputsl(inputsl => ({ ...inputsl, [town_label]: town }));

                            var town_text=response.data.data.town_name;
                            var town_name_lbl="town_name";
                            setInputsl(inputsl => ({ ...inputsl, [town_name_lbl]: town_text }));
                        }else{
                              setCity([]);
                              setTown([]);
                              var state_label3 = 'state';
                              var state3 = '';
                              setInputsl(inputsl => ({ ...inputsl, [state_label3]: state3 }));

                              var city_label3 = 'city';
                              var city3 = '';
                              setInputsl(inputsl => ({ ...inputsl, [city_label3]: city3 }));

                              var town_label3 = 'town';
                              var town3 = '';
                              setInputsl(inputsl => ({ ...inputsl, [town_label3]: town3 }));

                              var town_text3='';
                                  var town_name_lbl3="town_name";
                                  setInputsl(inputsl => ({ ...inputsl, [town_name_lbl3]: town_text3 }));
                        }
                    } else {
                        setCity([]);
                        setTown([]);
                        var state_label1 = 'state';
                        var state1 = '';
                        setInputsl(inputsl => ({ ...inputsl, [state_label1]: state1 }));

                        var city_label1 = 'city';
                        var city1 = '';
                        setInputsl(inputsl => ({ ...inputsl, [city_label1]: city1 }));

                        var town_label1 = 'town';
                        var town1 = '';
                        setInputsl(inputsl => ({ ...inputsl, [town_label1]: town1 }));

                        var town_text1='';
                        var town_name_lbl1="town_name";
                        setInputsl(inputsl => ({ ...inputsl, [town_name_lbl1]: town_text1 }));

                    }
                }).catch(error => {

                });
        }else{
            setCity([]);
            setTown([]);
            var state_label2 = 'state';
            var state2 = '';
            setInputsl(inputsl => ({ ...inputsl, [state_label2]: state2 }));

            var city_label2 = 'city';
            var city2 = '';
            setInputsl(inputsl => ({ ...inputsl, [city_label2]: city2 }));

            var town_label2 = 'town';
            var town2 = '';
            setInputsl(inputsl => ({ ...inputsl, [town_label2]: town2 }));

            var town_text2='';
                var town_name_lbl2="town_name";
                setInputsl(inputsl => ({ ...inputsl, [town_name_lbl2]: town_text2 }));
        }
    }

const getCity = (event) => {
      event.preventDefault();
      setInputsl(inputsl => ({ ...inputsl, [event.target.name]: event.target.value }));

      setTown([]);

      var st = 'city';
      var st_val = '';
      setInputsl(inputsl => ({ ...inputsl, [st]: st_val }));

      var ct = 'town';
      var ct_val = '';
      setInputsl(inputsl => ({ ...inputsl, [ct]: ct_val }));

      var ctt = 'category_id';
      var ctt_val = '';
      setInputsl(inputsl => ({ ...inputsl, [ctt]: ctt_val }));

      let formData = new FormData();
      formData.append('state_id', event.target.value);
      API.post('get_city', formData)
          .then(response => {

              if (response.data.status === true) {
                  setCity(response.data.data);
              } else {

              }
          }).catch(error => {

          });
  }

  const getTown = (event) => {
        event.preventDefault();
        setInputsl(inputsl => ({ ...inputsl, [event.target.name]: event.target.value }));
        setTown([]);

        var ct = 'town';
        var ct_val = '';
        setInputsl(inputsl => ({ ...inputsl, [ct]: ct_val }));

        var ctt = 'category_id';
        var ctt_val = '';
        setInputsl(inputsl => ({ ...inputsl, [ctt]: ctt_val }));
        let formData = new FormData();
        formData.append('city_id', event.target.value);
        API.post('get_town', formData)
            .then(response => {
                if (response.data.status === true) {
                    setTown(response.data.data);
                    var ct1 = 'town';
                  var ct_val1 = response.data.extra_data.town_id;
                  setInputsl(inputsl => ({ ...inputsl, [ct1]: ct_val1 }));

                  var pin1 = 'pincode';
                  var pin_val1 = response.data.extra_data.pincode;
                  setInputsl(inputsl => ({ ...inputsl, [pin1]: pin_val1 }));

                  var town_text=response.data.extra_data.town_name;
                  var town_name_lbl="town_name";
                  setInputsl(inputsl => ({ ...inputsl, [town_name_lbl]: town_text }));
                } else {

                }
            }).catch(error => {

            });
    }

    const getCat = (event) => {
        event.preventDefault();
         const selectedIndex = event.target.selectedIndex;
        setInputsl(inputsl => ({ ...inputsl, [event.target.name]: event.target.value }));

        var town_text=event.target.options[selectedIndex].text;
        var town_name_lbl="town_name";
        setInputsl(inputsl => ({ ...inputsl, [town_name_lbl]: town_text }));

        get_town_picode(event.target.value);
    }
    const get_town_picode = (id) => {
        let formData = new FormData();
        formData.append('town_id', id);
        API.post('get_town_pincode', formData)
            .then(response => {

                if (response.data.status === true) {
                    if (response.data.data.city_id !== '') {
                        var pincode_label = 'pincode';
                        var pincode_val = response.data.data.pincode;
                        setInputsl(inputsl => ({ ...inputsl, [pincode_label]: pincode_val }));
                    }
                } else {

                }
            }).catch(error => {

            });
    }

    const submitdata = () => {
      const validationErrors = validatelocationsearch(inputsl);
        const noErrors = Object.keys(validationErrors).length === 0;
        setErrors({});
        setErrors(validationErrors);

        if (noErrors) {
        	var townName1=inputsl.town_name+' '+inputsl.pincode;
        	setInputsla({ lat: '', lng: '', single_address: inputsl.town_name,address:townName1,city_id:inputsl.city,town_id:inputsl.town });
            //setTownLocation(inputsl.town_name,inputsl.town,inputsl.pincode,inputsl.city);
            setShows(false);
        }
    }

	return (
		<>
			<Topbar />
			<section className='bus-login-main'>
				<Container>
					<Row>
						<Col md={12} lg={5} >
							<h2 className='text-center blm-title'>{inputst.title}</h2>
							<p className='blm-desc'>{inputst.sub_title}</p>
							<div className="login-form-box">
								<div className='lfb-title'>
									<h2><span>Login </span>Business</h2>
								</div>
								<Form className='' onSubmit={handleSubmit}>
									<Form.Control type="text" className="mb-2" placeholder="Email Address" name="email" onChange={handleInputChange} value={inputs.email} />
									{errors.email && (<p className="text-danger">{errors.email}</p>)}
									<InputGroup className="">
										<Form.Control
											placeholder="Enter a Password"
											aria-label="password"
											aria-describedby="basic-addon1"
											type={showPassword ? 'text' : 'password'}
											name="password" onChange={handleInputChange} value={inputs.password}
										/>
										<InputGroup.Text id="basic-addon1" onClick={togglePassword}>
											{/*<Image src={showPassword ? '../assets/images/show.webp' : '../assets/images/hide.webp'} className="img-fluid" alt={showPassword ? 'hide' : 'show'} />*/}

											<Image
												src={
													showPassword
														? process.env.REACT_APP_BASE_URL + 'assets/images/hide.webp'
														: process.env.REACT_APP_BASE_URL + 'assets/images/show.webp'
												}
												className="img-fluid"
												alt={showPassword ? 'hide' : 'show'}
											/>
										</InputGroup.Text>
									</InputGroup>
									{errors.password && (<p className="text-danger">{errors.password}</p>)}
									<div className="fp-box">
										<Form.Check
											type="checkbox"
											id="notice"
											label="Remember me"
											name="remember_me"
											value="1" checked={inputs.remember_me} onChange={handleCheckboxChange}
										/>
										<Link to="/business/forgot-password">Forgot Password?</Link>
									</div>
									<Button variant="primary" type="submit" className='orange-icn-btn'>
										<h6>Login</h6> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/login.webp'} className="img-fluid" alt="login" />
									</Button>
								</Form>
								<div className='or-box'>
									<span>or</span>
								</div>
								<GoogleOAuthProvider clientId={process.env.REACT_APP_GMAIL_CLIENT_ID}>
									<GoogleSignInButton />
								</GoogleOAuthProvider>
								{/*<Link to="/" className='go-btn'><div><h6>Continue with Google</h6> <Image src="../assets/images/googlewh.webp" className="img-fluid" alt="googlewh"/></div></Link>*/}
								{/*<Link to="/" className='fb-btn'><div><h6>Continue with Facebook</h6> <Image src="../assets/images/fbwh.webp" className="img-fluid" alt="fbwh"/></div></Link>*/}
								<FacebookLogin
									appId={process.env.REACT_APP_FACEBOOK_APP_ID}
									autoLoad={false}
									fields="name,email,picture"
									callback={responseFacebook}
									render={(renderProps) => (
										<Link
											to="#"
											onClick={renderProps.onClick}
											className="fb-btn"
										>
											<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
												<h6 style={{ margin: 0 }}>Continue with Facebook</h6>
												<Image
													src={process.env.REACT_APP_BASE_URL + 'assets/images/fbwh.webp'}
													className="img-fluid"
													alt="fbwh"
													style={{ width: "24px", height: "24px" }}
												/>
											</div>
										</Link>
									)}
								/>

								<p>By signing up, you agree to our <Link to="/business/privacy">Privacy Policy</Link>,<Link to="/">Cookie Policy</Link>, and <Link to="/business/terms">Member Agreement</Link>.</p>
								<p>Do you want to Register a business? <Link to="/business/register">Click Here</Link></p>
							</div>
						</Col>
						<Col md={12} lg={7} className='bl-left'>
							<Row>
								<Col md={4} sm={4} xs={4}><Image src={inputst.image1} className="img-fluid" alt="lbimg1" /></Col>
								<Col md={4} sm={4} xs={4}><Image src={inputst.image2} className="img-fluid" alt="lbimg2" /></Col>
								<Col md={4} sm={4} xs={4}><Image src={inputst.image3} className="img-fluid" alt="lbimg3" /></Col>
							</Row>

							<h2>{inputst.title}</h2>
							<ul className='business-ul'>
								<li>{inputst.sub_title}</li>
								
							</ul>
							<Form className='city-form'>
								<Row>
									<h6>Explore Your Neighborhood</h6>
								</Row>
								<Row>
									<Col className="d-flex align-items-end" xs={8} sm={6}>
										<input type="text" className="loc-textbox w-100" value={inputsla.address} placeholder="Location" onClick={() => handleShows()} />
										<img alt="drop" className="img-fluid loc-img-log" src={process.env.REACT_APP_BASE_URL + 'assets/images/location.webp'} onClick={getCurrentLocationLogin}/>
									</Col>
									
									<Col xs={4} sm={6}>
										<Button variant="primary" type="button" className='orange-arrow-btn fw-500' onClick={SubmitLocation}>
											Go
										</Button>
									</Col>
								</Row>


								
							</Form>
						</Col>
					</Row>
				</Container>
			</section>

			<Footer />

			<Modal
				show={show}
				size="md"
				onHide={handleClose}
				backdrop="static"
				keyboard={false}
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>Login</Modal.Title>
				</Modal.Header>
				<Modal.Body className='review-modal'>
					<Row>
						<Col md={12} className="text-center">
							{/* Message */}
							<p style={{ lineHeight: "1.6", fontSize: "16px" }}>
								This email
								is already associated
								with a Neighbor user.
								Would you like to
								link a Business
								profile as well?
							</p>

							{/* Buttons */}
							<div className="mt-4 d-flex justify-content-center gap-3">
								<button className="btn btn-primary" onClick={handleYes}>
									Yes
								</button>

								<button className="btn btn-secondary" onClick={handleClose}>
									No
								</button>
							</div>

						</Col>
					</Row>
				</Modal.Body>
			</Modal>


			<Modal
		        show={shows}
		        onHide={handleCloses}
		        backdrop="static"
		        keyboard={false}
		        centered
		        className='add-city-modal'
		      >
		        <Modal.Header closeButton>
		          <h3>Select Location</h3>
		        </Modal.Header>
		        <Modal.Body>
		          <Form>
		            <Form.Group className="mb-3">
		              <Form.Label className='d-none'>Pin code</Form.Label>
		              <Form.Control type="text" placeholder="Pin code" name="pincode" onChange={handleInputChangeMo} onBlur={getpicode_town} value={inputsl.pincode} maxLength={6} />
		              {errors.pincode && (<p className="text-danger">{errors.pincode}</p>)}
		            </Form.Group>
		            <div className='or-box'>
		              <span>or</span>
		            </div>
		            <Form.Select aria-label="Default select example" name="state" onChange={getCity} value={inputsl.state}>
		              <option value="">State</option>
		              {state && state.map((val, index) => {
		                  return (
		                      <option value={val.id}>{val.name}</option>
		                  )
		              })}
		            </Form.Select>
		            {errors.state && (<p className="text-danger">{errors.state}</p>)}
		            <Form.Select aria-label="Default select example" name="city" onChange={getTown} value={inputsl.city}>
		              <option value="">City</option>
		              {city && city.map((val, index) => {
		                  return (
		                      <option value={val.id}>{val.name}</option>
		                  )
		              })}
		            </Form.Select>
		            {errors.city && (<p className="text-danger">{errors.city}</p>)}
		            <Form.Select aria-label="Default select example" name="town" onChange={getCat} value={inputsl.town}>
		              <option value="">Locality</option>
		              {town && town.map((val, index) => {
		                  return (
		                      <option value={val.id}>{val.name}</option>
		                  )
		              })}
		            </Form.Select>
		            {errors.town && (<p className="text-danger">{errors.town}</p>)}
		            <Button type="button" className='blue-btn' onClick={submitdata}>Select</Button>
		          </Form>
		        </Modal.Body>
		      </Modal>

			{loading && (
				<div className="loadingClass">
					<img src={loader} alt="loader" />
				</div>
			)}
		</>
	)
}
export default BusinessLogin;


